<template>
  <div class="max-w-xl mx-auto">
    <div class="border-2 border-gray-border rounded-md p-8">
      <h2 class="th-title">Bantuan</h2>
      <!-- <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nihil,
        cupiditate.
      </p> -->
      <form class="mt-10 space-y-5" @submit.prevent="sendHelp">
        <div class="flex flex-col">
          <label for="firstName">Nama</label>
          <input
            v-model="formHelp.name"
            id="firstName"
            name="firstName"
            type="text"
            class="mt-2 px-4 py-3 focus:outline-none border-2 border-gray-border rounded-md"
            required
          />
        </div>
        <div class="flex flex-col">
          <label for="email">Email</label>
          <input
            v-model="formHelp.email"
            id="email"
            name="_replyto"
            type="email"
            class="mt-2 px-4 py-3 focus:outline-none border-2 border-gray-border rounded-md"
            required
          />
        </div>
        <div class="flex flex-col">
          <label for="title">Judul</label>
          <input
            v-model="formHelp.title"
            id="title"
            name="title"
            type="text"
            class="mt-2 px-4 py-3 focus:outline-none border-2 border-gray-border rounded-md"
            required
          />
        </div>
        <div class="flex flex-col">
          <label for="description">Deskripsi</label>
          <textarea
            v-model="formHelp.description"
            name="description"
            id="description"
            cols="30"
            rows="5"
            class="mt-2 px-4 py-3 focus:outline-none border-2 border-gray-border rounded-md"
            required
          ></textarea>
        </div>
        <button
          :disabled="loading"
          :class="loading ? 'bg-purple-400' : 'bg-primary'"
          class="bg-primary text-white font-bold px-5 py-3 focus:outline-none rounded-md w-full"
          type="submit"
        >
          {{ loading ? "Sedang Mengirim..." : "Kirim" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formHelp: {
        name: null,
        email: null,
        title: null,
        description: null,
      },
      loading: false,
    }
  },
  methods: {
    sendHelp() {
      this.loading = true
      this.$store.dispatch('user/SEND_HELP', this.formHelp)
        .then(res => {
          this.notification.success({
            title: 'Berhasil Mengirim Bantuan',
            duration: 5000,
          })
        })
        .catch(res => {
          this.notification.error({
            title: 'Gagal Mengirim Bantuan',
            duration: 5000,
          })
        })
        .finally(() => {
          this.loading = false
          this.formHelp.title = null
          this.formHelp.description = null
        })
    },
  },
  mounted() {
    this.formHelp.name = this.user.name || null
    this.formHelp.email = this.user.email || null
  },
  computed: {
    user() { return this.$cookies.get('user') },
  },
}
</script>

<style>
</style>
